import { render, staticRenderFns } from "./GroupBlackList.vue?vue&type=template&id=d37abf42&scoped=true&"
import script from "./GroupBlackList.vue?vue&type=script&lang=js&"
export * from "./GroupBlackList.vue?vue&type=script&lang=js&"
import style0 from "./GroupBlackList.vue?vue&type=style&index=0&id=d37abf42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37abf42",
  null
  
)

export default component.exports